import api from "../security/api";

const save = (client, instance, file, arrayRequest) => {
    return api
        .post(`scheduledFile/save?client=${client}&instance=${instance}&file=${file}`, arrayRequest);
};

const scheduledFileService = {
    save
};


export default scheduledFileService;
